import { useEffect, useState } from "react";
import { Share, X } from "lucide-react";

const DISMISS_KEY = "flow-a2h-dismissed";

function isTauriNative(): boolean {
  if (typeof window === "undefined") return false;
  const w = window as unknown as Record<string, unknown>;
  return (
    "__TAURI_INTERNALS__" in w ||
    "__TAURI_METADATA__" in w ||
    "__TAURI__" in w
  );
}

function isiOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  return /iPhone|iPad|iPod/.test(ua) && !/CriOS|FxiOS/i.test(ua);
}

function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  return (
    (navigator as unknown as { standalone?: boolean }).standalone === true ||
    window.matchMedia("(display-mode: standalone)").matches
  );
}

export function AddToHomeBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Native (Tauri Mobile / Desktop) では不要
    if (isTauriNative()) return;
    if (!isiOS()) return;
    if (isStandalone()) return;
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-3 bottom-20 z-40 rounded-lg border border-border bg-card shadow-elevated dark:border-border-dark dark:bg-card-dark md:hidden">
      <div className="flex items-start gap-3 p-4">
        <div className="rounded-md bg-brand-500/10 p-2 text-brand-600 dark:text-brand-300">
          <Share className="h-5 w-5" />
        </div>
        <div className="flex-1 text-sm">
          <p className="font-semibold">ホーム画面に Flow を追加</p>
          <p className="mt-1 text-xs leading-relaxed text-muted dark:text-muted-dark">
            Safari 下部の <span className="font-medium">共有ボタン</span> →{" "}
            <span className="font-medium">「ホーム画面に追加」</span>
            で、アプリのように使えます。
          </p>
        </div>
        <button
          type="button"
          aria-label="閉じる"
          onClick={dismiss}
          className="rounded p-1 text-muted hover:bg-hover dark:text-muted-dark dark:hover:bg-hover-dark"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
